import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {GeneralService} from '../../../../../services/general.service';
import {Injectable} from '@angular/core';
import {IWhatsNew} from '../interfaces/IWhatsNew';
import {Page} from '../../../../../model/page';

@Injectable({providedIn: 'root'})
export class WhatsNewService extends GeneralService {
	getById(id): Observable<any> {

		if (id === 0) {
			return of(this.initialize());
		}

		const url = `${this.apiUrl}/whats-new/view`;
		return this.http.get(url, {params: {WN1_ID: id}});
	}

	save(whatsNew: IWhatsNew, isCreate: boolean): Observable<any> {
		return isCreate ? this.create(whatsNew) : this.update(whatsNew);
	}

	delete(whatsNew: any): Observable<any> {
		const url = `${this.apiUrl}/whats-new/delete`;
		return this.http.post(url, whatsNew);
	}

	public getDataList(page: Page): Observable<any> {
		const url = '/whats-new/index';
		return this.getRestList(page, url);
	}

	// Published news items the current user has not seen yet (Task #44804826).
	public getUnseen(): Observable<any> {
		return this.http.get(`${this.apiUrl}/whats-new/unseen`);
	}

	// Advance the user's "last seen" marker to the newest published news item.
	public markSeen(): Observable<any> {
		return this.http.post(`${this.apiUrl}/whats-new/mark-seen`, {});
	}

	public initialize() {
		return {
			WN1_ID: null,
			WN1_VERSION: null,
			WN1_RELEASE_DATE: null,
			WN1_STATUS: null,
			WN1_EDI_PORTAL_TITLE: null,
			WN1_EDI_PORTAL_TEXT: null,
			WN1_SUPPLIER_GATEWAY_TITLE: null,
			WN1_SUPPLIER_GATEWAY_TEXT: null,
			WN1_CUSTOMER_GATEWAY_TITLE: null,
			WN1_CUSTOMER_GATEWAY_TEXT: null,
			WN1_CONFIG_SETUP_TITLE: null,
			WN1_CONFIG_SETUP_TEXT: null,
			WN1_CREATED_ON: null,
			WN1_CREATED_BY: null,
			WN1_MODIFIED_ON: null,
			WN1_MODIFIED_BY: null,
			WN1_DELETE_FLAG: null,
			WN1_UPDATE_FLAG: null
		};
	}

	private create(whatsNew: IWhatsNew): Observable<any> {
		const url = `${this.apiUrl}/whats-new/create`;
		return this.http.post(url, whatsNew);
	}

	private update(whatsNew: IWhatsNew): Observable<any> {
		const url = `${this.apiUrl}/whats-new/update`;
		return this.http.put(url, whatsNew);
	}
}
